import request from '../../axios';

const getAgentStoreDetail = async (guid: string) => {
  const {data}: {data: IAgentDetail} = await request.get(
    `api/v2/store/sale-agent-detail/${guid}`,
  );

  return data;
};

export default getAgentStoreDetail;
